module.exports = __webpack_public_path__ + "media/images/green-01a58f95acd82bbed6bbb58131333554.png";